import React, { useMemo, useState } from 'react';

import successBg from '@/assets/details/successBg.png';
import icon_party from '@/assets/emoji/party-popper.png';
import NotifyBtn from '../../AccountSetting/Notify/NotifyBtn';
import { useAppSelector } from 'store/hooks';
import classNames from 'classnames';
import MintWallet from './MintWallet';
import multiplierIcon from '@/assets/emoji/multiplier.png';
import CopyToClipboard from 'react-copy-to-clipboard';
import { successMsg } from '@/components/PageElement/SuccessMessage';
import icon_show from '@/assets/details/icons/icon_show.png';
import icon_hide from '@/assets/details/icons/icon_hide.png';

const Won = () => {
  const {
    raffleInfo: {
      whitelist_method,
      more_info_for_winners,
      role_based_dc_invite_link,
      role_based_dc_server_name,
      my_entry,
    },
  } = useAppSelector((state) => state.raffleDetails);
  const [showCode, setShowCode] = useState(false);

  const textRender = useMemo(() => {
    if (whitelist_method === 'DTC') {
      return (
        <div>
          <div>Wallets will be added direct to contract.</div>
          {!!more_info_for_winners && <div>{more_info_for_winners}</div>}
        </div>
      );
    } else if (whitelist_method === 'DC_ROLE_BASED') {
      return (
        <div>
          <div>
            Winners to join{' '}
            <a
              href={
                role_based_dc_invite_link?.includes('http')
                  ? role_based_dc_invite_link
                  : 'https://'.concat(role_based_dc_invite_link as string)
              }
              target="_blank"
              rel="noreferrer"
            >
              {role_based_dc_server_name}
            </a>{' '}
            to get required role.
          </div>
          {!!more_info_for_winners && <div>{more_info_for_winners}</div>}
        </div>
      );
    } else if (!!more_info_for_winners) {
      return <div>{more_info_for_winners}</div>;
    } else {
      return null;
    }
  }, [
    more_info_for_winners,
    role_based_dc_invite_link,
    role_based_dc_server_name,
    whitelist_method,
  ]);

  return (
    <div>
      <div className="automateBg -mx-5 -mt-6 rounded-t-2xl">
        <div
          className={classNames('bg-cover bg-repeat px-5 py-6 text-center')}
          style={{ backgroundImage: `url(${successBg.src})` }}
        >
          <div className="flex items-center justify-center gap-3">
            <img src={icon_party.src} className="w-8" alt="" />
            <div className="text-xl font-semibold text-neutral-1000">
              Congratulations
            </div>
          </div>
          <div className="my-2 text-sm font-normal text-neutral-900">
            You won!
          </div>
          <div className="rounded-2xl bg-[rgba(0,0,0,0.6)] p-3 text-center text-base font-normal">
            <div>
              <div className="text-neutral-200 ">You submitted:</div>
              <div className="mt-2 break-all text-neutral-200">
                <MintWallet />
              </div>
            </div>
            {!!my_entry?.award_code && (
              <div className="mt-2">
                <div className="text-neutral-200 ">Your Code:</div>
                <div className="mt-2 flex flex-wrap items-center justify-center gap-2 break-all text-neutral-200">
                  <CopyToClipboard
                    text={my_entry?.award_code}
                    onCopy={() => {
                      successMsg('Copied to clipboard');
                    }}
                  >
                    <div className="cursor-pointer text-base font-semibold text-neutral-100 flex items-center justify-center">
                      {showCode ? (
                        <span>{my_entry?.award_code}</span>
                      ) : (
                        <span>
                          {Array.from(
                            { length: my_entry?.award_code?.length },
                            (_, index) => index + 1
                          )?.map((index) => '*')}
                        </span>
                      )}
                    </div>
                  </CopyToClipboard>
                  <img
                    src={!showCode ? icon_hide.src : icon_show.src}
                    alt=""
                    className="w-4 cursor-pointer"
                    onClick={() => {
                      setShowCode((show) => !show);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {!!textRender && (
        <div className="mt-4 text-center text-base font-normal text-neutral-200">
          {textRender}
        </div>
      )}
      <NotifyBtn />
    </div>
  );
};

export default Won;
